module.exports = __webpack_public_path__ + "static/media/cico-logo-regular.8c448da5.svg";